import { BASE_URL_ARES } from '../misc/consts';
const BASE_URL_AUDITS = '/api/collections/audits/entries';

export default () => ({
  certificates: [
    {
      certification: '',
      firstTime: 'true',
    },
  ],
  tab: 0,
  ic: null,
  field: '',
  aresData: null,
  allAudits: [],

  certificationsString() {
    // Ensure SumoSelect values are synced with Alpine.js data
    this.syncSumoSelectValues();
    return this.certificates.map((cert) => cert.certification).filter(cert => cert).join(', ');
  },

  syncSumoSelectValues() {
    // Sync SumoSelect values with Alpine.js data
    const selects = document.querySelectorAll('select.form-input');
    selects.forEach((select, index) => {
      if (this.certificates[index]) {
        try {
          // Check if SumoSelect is initialized
          if (select.sumo) {
            const selectedValue = select.sumo.val();
            if (selectedValue && selectedValue.length > 0) {
              this.certificates[index].certification = selectedValue[0];
            }
          } else {
            // Fallback to regular select value
            if (select.value) {
              this.certificates[index].certification = select.value;
            }
          }
        } catch (e) {
          console.log('Error syncing select value:', e);
          // Fallback to regular select value
          if (select.value) {
            this.certificates[index].certification = select.value;
          }
        }
      }
    });
  },

  updateCertificationsValue() {
    // Update the hidden input value right before form submission
    this.syncSumoSelectValues();
    const certificationsString = this.certificates.map((cert) => cert.certification).filter(cert => cert).join(', ');
    const hiddenInput = this.$refs.certificationsInput;
    if (hiddenInput) {
      hiddenInput.value = certificationsString;
    }
  },

  addCert() {
    this.certificates.push({
      certification: '',
      firstTime: 'true',
    });
    this.$nextTick(() => {
      $('select.form-input').SumoSelect();
    });
    this.tab = this.certificates.length - 1;
  },

  removeCert(index) {
    if (this.tab >= this.certificates.length - 1) {
      this.tab--;
    }
    this.certificates.splice(index + 1, 1);
    this.$nextTick(() => {
      $('select.form-input').each((index, item) => {
        item.sumo.reload();
      });
    });
  },

  certificatesReset() {
    this.tab = 0;
    this.$nextTick(() => {
      $('select.form-input')[0].sumo.reload();
      this.certificates = [
        {
          certification: '',
          firstTime: 'true',
        },
      ];
    });
  },

  get altTitle() {
    if (this.certificates[this.tab].certification) {
      const audit = this.allAudits.find(
        (audit) => audit.title === this.certificates[this.tab].certification
      );
      if (audit) {
        return audit.alternative_title;
      }
    }
    return '';
  },

  async getAresData() {
    const response = await fetch(`${BASE_URL_ARES}${this.ic}`);
    const data = await response.json();
    this.aresData = data.original;
  },

  init() {
    return fetch(
      `${BASE_URL_AUDITS}?filter[published:is]=true&sort=title&filter[site]=cs&fields=title,alternative_title`
    )
      .then((response) => response.json())
      .then((response) => {
        this.allAudits = response.data.map((audit) => ({
          title: audit.title,
          alternative_title: audit.alternative_title,
        }));
      });
  },
});
